import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { hasAccessToken } from "./authStorage";

function PublicOnlyRoute() {
  if (hasAccessToken()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}

export default PublicOnlyRoute;
